import { createFileRoute, Link } from "@tanstack/react-router";
import { AppLegalLayout } from "@/components/AppLegalLayout";
import { UNITS } from "@/data/units";

const TITLE = "Suporte | Nook Gym";
const DESC = "Suporte do app Nookers: fale com a Nook Gym por WhatsApp, e-mail ou na recepção.";

export const Route = createFileRoute("/suporte")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://nookgym.com.br/suporte" }],
  }),
  component: Page,
});

function Page() {
  return (
    <AppLegalLayout title="Suporte do app Nookers">
      <p>O Nookers é o aplicativo dos alunos da Nook Gym. Se você tiver qualquer problema com o app, fale com a gente.</p>

      <h2>Fale com a gente</h2>
      <ul>
        <li>
          <strong>WhatsApp:</strong>
          <span className="mt-3 flex flex-wrap gap-2">
            {UNITS.map((u) => (
              <a
                key={u.slug}
                href={`https://wa.me/${u.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-10 items-center rounded-sm bg-nook-green px-4 text-[0.72rem] font-semibold uppercase tracking-[0.14em] !text-nook-green-foreground !no-underline"
              >
                {u.shortName}
              </a>
            ))}
          </span>
        </li>
        <li>
          <strong>E-mail:</strong> <a href="mailto:privacidade@nookgym.com.br">privacidade@nookgym.com.br</a>
        </li>
        <li>
          <strong>Na academia:</strong> a recepção da sua unidade também ajuda com o app.
        </li>
      </ul>
      <p>Respondemos em até 2 dias úteis.</p>

      <h2>Perguntas frequentes</h2>
      <p><strong>Como eu crio minha conta?</strong><br />O cadastro no app pede um código que a recepção da Nook entrega no momento da matrícula. Se você é aluno e ainda não tem o código, peça na recepção da sua unidade.</p>
      <p><strong>Esqueci minha senha.</strong><br />Fale com a gente pelo WhatsApp ou na recepção da sua unidade que ajudamos você a voltar a entrar.</p>
      <p><strong>Como conecto o Apple Saúde ou o Strava?</strong><br />No app, vá em Perfil → Configurações e toque em conectar. Você pode desconectar quando quiser no mesmo lugar.</p>
      <p><strong>Como pago minha mensalidade?</strong><br />O app não faz cobranças. Mensalidades e contratos são tratados na recepção da academia.</p>
      <p><strong>Como excluo minha conta?</strong><br />Veja o passo a passo em <Link to="/excluir-conta">Exclusão de conta</Link>.</p>

      <p>
        Veja também: <Link to="/politica-de-privacidade">Política de Privacidade</Link> ·{" "}
        <Link to="/termos-de-uso">Termos de Uso</Link>.
      </p>
    </AppLegalLayout>
  );
}
